import React from 'react';
import {useForm} from 'react-hook-form';
import {generateRoute, useRoutes} from '../../routing/RouteProvider';
import {useHistory} from 'react-router';
import {formatISO, startOfToday} from 'date-fns';
import FulltextInput from './fields/FulltextInput';
import {useTranslation} from '../../config/TranslationProvider';

const NavbarSearchForm = ({className}) => {
    const routes = useRoutes();
    const history = useHistory();
    const filterPath = query => generateRoute(routes, 'events', {filter: query});

    const {register, handleSubmit} = useForm();

    const defaultFilter = {
        'end_date_from': formatISO(startOfToday()),
    };

    const handleUserKeyPress = e => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(onSubmit)();
        }
    };

    const onSubmit = formData => {
        if (formData.fulltext !== '' && formData.fulltext.length > 2) {
            const query = {...defaultFilter, ...formData};
            const url = filterPath(query);
            history.push(url);
        }
    };

    return (
        <>
            <p id="navbar-filter-description" className="sr-only">
                {useTranslation('navbar_filter_description')}
            </p>
            <form onFocus={handleUserKeyPress} aria-describedby="navbar-filter-description">
                <label className={'search-wrapper ' + className} htmlFor="fulltextSearchNavigation">
                    <div className="nav_right_module search_module">
                        <button className="icon-left" onClick={handleSubmit(onSubmit)} type="submit" aria-label={useTranslation('search_events')}>
                            <i className="la la-search" />
                        </button>
                        <div className="search_area">
                            <div className="input-group">
                                <FulltextInput
                                    register={register}
                                    id="fulltextSearchNavigation"
                                    ariaLabel={useTranslation('fulltext_search_events')}
                                />
                            </div>
                        </div>
                    </div>
                </label>
            </form>
        </>
    );

};

export default NavbarSearchForm;
